<template>
  <div v-if="about">
    <h3 class="mb-5">What Our Partners Says</h3>
    <div class="h4 mb-5">顯示於AboutUs頁面</div>

    <!-- Title -->
    <label class="form-item d-flex pt-5">
      <h4 class="w-180px">Title</h4>
      <div class="flex-grow-1 my-n2">
        <v-textarea
          v-model="about.partner_title"
          outlined
          dense
        ></v-textarea>
      </div>
    </label>
    <!-- Content -->
    <label class="form-item d-flex pt-5">
      <h4 class="w-180px">SubTitle</h4>
      <div class="flex-grow-1 my-n2">
        <v-textarea
          v-model="about.partner_subtitle"
          outlined
          dense
        ></v-textarea>
      </div>
    </label>
    <!-- img uploader -->
    <div class="pa-5 d-flex">
      <div class="w-180px">
        <h4>Banner</h4>
        <div class="h5 ink-02-medium--text">
          建議尺寸：600px * 600px <br />
          檔案大小限制：≤ 20 MB <br />
          支援格式：.png/.jpg/.gif
        </div>
      </div>
      <div class="flex-grow-1">
        <ImgUploader
          :imageUrl.sync="about.partner_banner"
          dir="about"></ImgUploader>
      </div>
    </div>
  </div>
</template>

<script>
import ImgUploader from '@/components/ImgUploader.vue';

export default {
  props: {
    about: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    ImgUploader,
  },
};
</script>

<style></style>
